import React from 'react';

const CTA = () => {
  return (
    <section id='cta'>
      <div className='container tc'>
        <div className='s-64'></div>
        <h3 className='title-sub'>Starten Sie Ihre IT-Umschulung jetzt</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          IT-Weiterbildung für Quereinsteiger—gefördert von der Agentur für Arbeit
        </h4>
        <div className='s-48'></div>
        <div className='card tl b-none p-5'>
          <div className='m-5'>
            <div className='row'>
              <div className='col-lg-6'>
                <h3 className='title-sub w-100' style={{ lineHeight: 1.2 }}>
                  Jetzt IT-Kurs mit Bildungsgutschein oder Förderung wählen
                </h3>
                <div className='s-40'></div>
                <a href='/sign-in' className='button'>
                  Bereich wählen
                </a>
              </div>
              <div className='col-lg-6'></div>
            </div>
          </div>
        </div>
        <div className='s-80'></div>
      </div>
    </section>
  );
};

export { CTA };